import React from 'react';

import LargeSizeContext from 'contexts/largeSizeContext';

type LargeSizeProviderProps = {
  children: React.ReactNode;
  isLargeMode: boolean;
};

export default function LargeSizeProvider({
  children,
  isLargeMode,
}: LargeSizeProviderProps): JSX.Element {
  return (
    <LargeSizeContext.Provider value={{ isLargeMode }}>
      {children}
    </LargeSizeContext.Provider>
  );
}
